import { render, staticRenderFns } from "./ModalSplitFile.vue?vue&type=template&id=50a07d51&"
import script from "./ModalSplitFile.vue?vue&type=script&lang=js&"
export * from "./ModalSplitFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports